// REACT
import React, { Component } from 'react';

// STYLING
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import IconButton from 'components/Button/IconButton';
import FlexRow from 'components/Primatives/FlexRow';

import { constants } from '../../../constants';


const StyledTimeBlock = styled(FlexRow)`
    color: white;
    text-align: center;
    background-color: ${constants.color.primaryDark};
    font-size: 12px;
    border-radius: 15px;
    margin: 12px 8px;
    padding: 10px 20px;
    box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
    flex: none;
`;

const StyledTimeBlockComponent = ({
    timeBlock,
    showDeleteConfirmationDialog,
    deleteType,
    formName,
    index,
    editModalForm,
    getDialogContent
}) => {
    let deleteData = {
        timeBlockIndex:index,
        day:formName
    };
    return (
        <StyledTimeBlock id='StyledTimeBlock'>
            <FlexRow style={{ alignItems: 'center' }}>
                {timeBlock[0]} - {timeBlock[1]}
                {/* <IconButton onClick={() => getDialogContent(editModalForm, "Edit Availability")}>
                        <FontAwesomeIcon 
                            icon={['far', 'pencil']}
                            style={{ opacity: 1 }}
                            size={"1x"}
                            color="#FFFFFF"
                        />
                </IconButton> */}
                <IconButton onClick={(e) => {showDeleteConfirmationDialog(e, deleteData, deleteType, timeBlock)}}>
                    <FontAwesomeIcon 
                        icon={['far', 'trash-alt']}
                        style={{ opacity: 1 }}
                        size={"1x"}
                        color="white"
                    />
                </IconButton>
            </FlexRow>
        </StyledTimeBlock>
    );
};

export default StyledTimeBlockComponent;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/components/StyledTimeBlockComponent.jsx